/** Markdown as one line of plain text, for a table cell or a one-line summary. */
export function plainText(markdown: string): string {
  return withLineBreaks(markdown)
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')
    .replace(/^\s*(?:[-*+]|\d+[.)])\s+/gm, '')
    .replace(/^\s*>\s?/gm, '')
    .replace(/!?\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/(\*\*|__|\*|_|~~|`)(\S(?:.*?\S)?)\1/g, '$2')
    .replace(/\|/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Results saved before line breaks were kept are one long line ("## Agenda - **15:00** ...").
 * Put a break back before each heading and list item so they read as Markdown again.
 */
export function withLineBreaks(markdown: string): string {
  if (markdown.includes('\n')) return markdown;
  return markdown
    .replace(/\s+(#{1,6}\s)/g, '\n\n$1')
    .replace(/\s+-\s+(?=\S)/g, '\n- ')
    .replace(/\s+(\d{1,2}\.\s+(?=\*\*|\[|[A-Z]))/g, '\n$1');
}
